import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Message } from 'rsuite';
//import { renderCount } from '../../../../appHelpers/appLoggers';
import styled from 'styled-components';

export const UpdateMessageFC = () => {
   const [padding, setPadding] = useState(20);

   const handleMessageClose = () => {
      setPadding(0);
   }

   const currentHour = new Date().getHours();

   useEffect(() => {
    
   }, [padding]);

   return (
   <UpdateMessageSC>
      <MessageBox paddingSize={padding}>
         <Message closable showIcon type="info" header="Technical Issue" onClose={handleMessageClose}>
            Our remote site is currently experiencing technical issues. Some not all of your remotes are OFFLINE. We are actively working to resolve the problem and will provide an update as soon as possible. 
         
            <br/><br/>Please ensure you perform manual reads for magnet data until the issue is resolved. 
            <br/><br/>Sincerely,<br/>

            Avante Remote Technology Team
         </Message>
      </MessageBox>
   </UpdateMessageSC>
   );
}

const MessageBox = styled.div`
   padding-top: 75px;
   place-self: anchor-center;
   width: 95%;

   @media screen and (min-width: 769px) {
      padding-top: 75px;
      padding-left: 25px;
      place-self: anchor-center;
      width: 95%;
   }
`

const UpdateMessageSC = styled.div`
   .rs-message-info {
      background-color: rgb(0, 91, 148);
      color: white;
   }

   .rs-message-warning {
      background-color:  #ffb300;
      color: white;
   }

    .rs-message-info .rs-icon {
      fill: white;
   }

   .rs-message-warning .rs-icon {
      fill: black;
   }
   
   .rs-message-info .rs-message-body {
      color: white;
   }

   .rs-message-warning .rs-message-body {
      color: black;
   }

   .rs-message-info .rs-message-header {
      color: white;
   }
   
   width: 95vw;
`